<template>
  <div class="pc-isDetail-detail">
    <h2 v-if="header == '新闻'">新闻正文</h2>
    <h2 v-else>{{ header }}详情</h2>
    <div class="edit" v-if="isEditting">
      <TemplateUeditor v-model="innerContent"/>
    </div>
    <div v-else-if="content" class="detai-world" v-html="content"></div>
    <div v-else>暂无内容</div>
  </div>
</template>
<script>
import TemplateUeditor from "./Ueditor";

export default {
  props: { 
    content:String,
    header:String,
    isEditting:Boolean
  },
  components: {
    TemplateUeditor,
  },
  data() {
    return {
      innerContent:''
    };
  },
  mounted(){
     console.log(this.content)
  },
  watch:{
      content(newV,oldV){
          this.innerContent = newV
      }
  },
  methods:{
      getContent(){
          return this.innerContent
      }
  }

};
</script>
<style lang="scss" scoped>
.pc-isDetail-detail {
  box-shadow: $boxshadow;
  padding: 35px 30px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    margin-bottom: 21px;
    color: $mainTitle;
  }
  .detai-world {
    margin-top: 20px;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/EditContent.vue